import { React } from 'react';
import ServiceSection from '../../../../ServiceSection/ServiceSection';
import SatelliteText from '../../../SatelliteText/SatelliteText';
import satelliteIcon from '../../../satelliteIcon';

const CustomVsStandardSoftware6 = props => (
    <ServiceSection noPadBottom noPadTitle singleTitle icon={satelliteIcon} {...props} page="customVsStandardSoftware" section="alwaysMoreExpensive">
        <div className='TextGroup Satellite'>
            <div className='container-custom subtitle'>
                <SatelliteText t={props.t} prefix="customVsStandardSoftware:alwaysMoreExpensive" first />
            </div>
        </div>
    </ServiceSection>
);

export default CustomVsStandardSoftware6;
